/** Widget shopper journey - used for compact previews across Integrations. */
export const WIDGET_EMBED_STAGES = [
  { id: "quote", label: "Quote" },
  { id: "priced", label: "Price" },
  { id: "payment", label: "Pay" },
  { id: "confirmed", label: "Booked" },
  { id: "tracking", label: "Trip" },
];

/** Partner API server journey - catalog then quote, book, pay, track. */
export const PARTNER_API_STAGES = [
  { id: "catalog", label: "Vehicles" },
  { id: "quote", label: "Quote" },
  { id: "order", label: "Book" },
  { id: "payment", label: "Pay" },
  { id: "track", label: "Track" },
];
